import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { DiaryFormElement } from "../../../../../core/models/trial-diary-form/diary-form-element.model";
import { DiaryFormElementType } from "../../../../../core/constants/diary-form-element-type.enum";

@Component({
  selector: 'app-trial-diary-form-element-renderer',
  templateUrl: './trial-diary-form-element-renderer.component.html',
  styleUrl: './trial-diary-form-element-renderer.component.scss'
})
export class TrialDiaryFormElementRendererComponent implements AfterViewInit {
  @Output() elementMoveUp = new EventEmitter<DiaryFormElement>();
  @Output() elementMoveDown = new EventEmitter<DiaryFormElement>();
  @Output() elementManage = new EventEmitter<DiaryFormElement>();
  @Output() elementRemove = new EventEmitter<DiaryFormElement>();
  @Output() messageRemove = new EventEmitter<number>();
  @Output() messageEdit = new EventEmitter<number>();
  @Output() messageAdd = new EventEmitter<DiaryFormElement>();
  @Output() visibilityEdit = new EventEmitter<DiaryFormElement>();

  @Input() element: DiaryFormElement;
  @Input() index: number = 0;
  @Input() hasEntries: boolean = false;
  @Input() allElements: DiaryFormElement[] = [];
  @Input() showCompletionWarning: boolean = false;

  DiaryFormElementType = DiaryFormElementType;

  ngAfterViewInit() {
  }
}
